import styled from 'styled-components';
import { BREAKPOINTS, COLORS } from '@laerdal/life-react-components';

export const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    align-self: stretch;
`;

export const StepHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

export const StepTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${COLORS.black};
  margin: 0;
  flex: 1;
`;

export const StepDescription = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${COLORS.neutral_700};
  margin: 0;
`;


export const GrayBox = styled.p`
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    border-radius: 8px;
    background: ${COLORS.neutral_50};
`;


export const ChoseFileContainer = styled.div`
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    

    height: 152px;
    gap:21px;

    
    border-radius: 4px;
    //border: 1px dashed #949494;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none'  rx='4' ry='4' stroke='%23949494' stroke-width='2' stroke-dasharray='16%2c 16' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e");
`;


export const AttachmentsContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: start;
  gap: 16px;
  background-color: ${COLORS.neutral_20};
  padding: 24px 30px;
`;

export const AttachmentDetails = styled.div`
  ${BREAKPOINTS.MEDIUM}{
    padding: 0px 10px;
  }
  padding: 5px 10px;

  background-color: ${COLORS.white};
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const AttachmentHeader = styled.div`
  display:flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const CustomTextareaContainera = styled.div`
  & > div {
    display: flex;
  }

  & > div > textarea {
    width:100% !important;
    font-family: 'Lato';
  }
`